import { render, staticRenderFns } from "./AssistPanel.vue?vue&type=template&id=79b3a036&scoped=true"
import script from "./AssistPanel.vue?vue&type=script&lang=ts"
export * from "./AssistPanel.vue?vue&type=script&lang=ts"
import style0 from "./AssistPanel.vue?vue&type=style&index=0&id=79b3a036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b3a036",
  null
  
)

export default component.exports